import { createFileRoute } from '@tanstack/react-router'

import { StationsPage } from '@/pages/stations-page'

export const Route = createFileRoute('/_dashboard-layout/stations')({
    component: StationsPage,
})
